import React from 'react';
import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import '../../../../../../assets/css/dialogs.css';

const SECTIONS = [
	{
		code: 'recommended_place',
		labelKey: 'recommendation_section_short_place',
		hintKey: 'recommendation_section_place_hint'
	},
	{
		code: 'recommended_food',
		labelKey: 'recommendation_section_short_food',
		hintKey: 'recommendation_section_food_hint'
	}
];

// Step 1 of the recommendation wizard: section + name + description.
const RecommendationNameAndDetails = ({
	section,
	setSection,
	name,
	setName,
	description,
	setDescription
}) => {
	const maxLength = 60;
	const dictionary = useDictionary();

	const onNameChanged = (e) => {
		if (e.target.value.trim().length <= maxLength) {
			setName(e.target.value);
		}
	};

	return (
		<div className="new-experience-form-wrapper">
			<div className="new-experience-form-container thin-scrollbar-trans">
				<h2>{dictionary.recommendation_step_details}</h2>

				<div style={{ marginTop: '15px' }} className="text">
					{dictionary.recommendation_name}
				</div>
				<div className="group-inputs text-name-wrapper">
					<input
						type="text"
						value={name}
						onChange={onNameChanged}
						placeholder={dictionary.recommendation_name_placeholder}
						data-testid="recommendation-name-input"
					/>
				</div>
				<div className="textarea-info-row m-zero">
					<div className="text" style={{ color: '#22264C99' }}>
						{name.trim().length + '/' + maxLength}
					</div>
				</div>

				<div style={{ marginTop: '15px' }} className="text">
					{dictionary.recommendation_description}
				</div>
				<textarea
					value={description ? description : ''}
					onChange={(e) => setDescription(e.target.value)}
					placeholder={dictionary.recommendation_description_placeholder}
					data-testid="recommendation-description-input"
				/>

				<div style={{ marginTop: '15px' }} className="text">
					{dictionary.recommendation_section}
				</div>
				{/* Stacked radios, same style as the experience sales-channel picker. */}
				<div className="channel-pick-options" style={{ marginTop: '8px' }}>
					{SECTIONS.map((item) => (
						<label key={item.code} className="channel-pick-option">
							<input
								type="radio"
								className="channel-pick-input"
								name="recommendation-section"
								checked={section === item.code}
								onChange={() => setSection(item.code)}
								data-testid={`recommendation-section-${item.code}`}
							/>
							<span className="channel-pick-radio" aria-hidden="true" />
							<span className="channel-pick-label">
								{dictionary[item.labelKey]}
								<span className="channel-pick-hint">
									({dictionary[item.hintKey]})
								</span>
							</span>
						</label>
					))}
				</div>
			</div>
		</div>
	);
};

RecommendationNameAndDetails.propTypes = {
	section: PropTypes.string.isRequired,
	setSection: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	setName: PropTypes.func.isRequired,
	description: PropTypes.string,
	setDescription: PropTypes.func.isRequired
};

export default RecommendationNameAndDetails;
